import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import SpinningLogo from '../../components/Spinner';
import CustomPageHeader from '../../components/CustomPageHeader';
import { downloadExcel } from '../../utils/DownloadXls';
import moment from 'moment';
import { Edit, Trash } from 'lucide-react';
import BtnSpinner from '../../components/BtnSpinner';
import Pagination from '../../components/Pagination';
import { Apirequests } from '../../utils/ApiRequests';
import { ErrorTost, SuccessTost } from '../../utils/ToastHelper';
import CustomOffCanvas from '../../components/CustomOffCanvas';
import ClassDetails from './ClassDetails';
import AddOrEditClass from './AddOrEditClass';

function Classes() {

  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState({ state: false, name: "" });
  const [classes, setClasses] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState({ state: false, name: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [refresh, setRefresh] = useState(false);
  const [currentClass, setCurrentClass] = useState(null);
  const [deleteId, setdeleteId] = useState(null)

  const token = localStorage.getItem("token");


  const totalItems = classes?.length; // Total number of items
  const itemsPerPage = 10;

  const currentData = classes?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const navigate = useNavigate();

  const handleRefresh = () => setRefresh(!refresh);

  const handleSearch = async () => {
    if (!searchTerm) {
      return ErrorTost("Enter a key to serach")
    }

    if(currentPage!==1){
      setCurrentPage(1)
    }
    
    await fetchclasses(searchTerm)
  };

  const fetchclasses = async () => {

    setLoading({ state: true, name: "fetchclasses" });

    try {
      const fetcedclasses = await Apirequests(`classes/get-classes?q=${searchTerm}`, 'GET', {}, {
        Authorization: `Bearer ${token}`
      });
      // console.log(fetcedclasses,'fetch class res')
      if (fetcedclasses?.success) {
        setClasses(fetcedclasses?.data)
      }
    } catch (error) {
      console.log('fetch classes error')
    }
    setLoading({ state: false, name: "" })
  }

  const deleteClass = async (id) => {
    setdeleteId(id);
    setLoading({ state: true, name: "deleteclass" })
    try {
      const delRes = await Apirequests(`classes/delete-class/${id}`, 'DELETE', {}, {
        Authorization: `Bearer ${token}`
      });

      if (delRes?.success) {
        SuccessTost(delRes?.message);
        setRefresh(!refresh)
      } else {
        ErrorTost(delRes?.message)
      }
    } catch (error) {
      console.log(error, 'delete class error');
      ErrorTost("Something went wrong, please try again later.")
    }
    setLoading({ state: false, name: "" })
  }

  useEffect(() => {
    fetchclasses()
  }, [refresh, token])

  if (loading.state && loading.name === "fetchclasses") {
    return <div className='h-screen w-full flex items-center justify-center bg-[rgba(255,255,255,0.5)]'>
      <SpinningLogo />
    </div>
  }

  return (
    <div>
      <CustomPageHeader
        title={"Classes"}
        text={searchTerm}
        setText={setSearchTerm}
        handleSearch={handleSearch}
        onClick={() => setIsOffCanvasOpen({ state: true, name: "addclass" })}
        btnText={"Add Class"}
        handleBackClick={() => navigate("/")}
        handleRefresh={handleRefresh}
        handleDownload={() => downloadExcel(classes, 'classes')}
      />

      <main className="mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead className="bg-gray-50 text-center">
                <tr>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Class Title</th>
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Price Text</th> */}
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date Text</th> */}
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Time Text</th> */}
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Time</th> */}
                  {/* <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Page Link</th> */}
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Language</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Join Btn Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Created At</th>
                  <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 text-center">
                {currentData?.map((cl) => (
                  <tr key={cl._id}>
                    <td className="px-6 py-4 whitespace-nowrap"><span className='text-indigo-600 cursor-pointer' onClick={() => { setIsOffCanvasOpen({ state: true, name: "viewclass" }); setCurrentClass(cl) }}>{cl?.title}</span></td>
                    <td className="px-6 py-4 whitespace-nowrap">{cl?.price}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(cl?.date).format("DD-MM-YY")}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{cl?.language}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{cl?.joinBtn? "Show":"Hide"}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{cl?.status}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{moment(cl?.createdAt).format("DD-MM-YY")}</td>
                    <td className="px-6 py-4 flex gap-5 justify-center">
                      <button className='flex bg-indigo-400 rounded-lg px-3 py-2 items-center gap-1' onClick={() => { setIsOffCanvasOpen({ state: true, name: "editclass" }); setCurrentClass(cl) }}>
                        <Edit className='text-white' size={20} />
                        <span className='text-white text-sm'>Edit</span>
                      </button>
                      <button className='flex bg-red-200 rounded-lg px-3 py-2 items-center gap-1' onClick={() => deleteClass(cl?.class_id)}>
                        {
                          loading.state && loading.name === "deleteclass" && deleteId === cl?.class_id ?
                            <BtnSpinner /> :
                            <>
                              <Trash className='text-red-700 text-sm' size={20} />
                              <span className='text-red-700 text-sm'>Delete</span>
                            </>
                        }

                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {classes?.length ?
          <div className="flex gap-x-2 items-center justify-between">
            <p>total: {classes?.length}</p>
            <Pagination
              page={currentPage}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div> : null}
      </main>

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "viewclass"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentClass(null) }}
        content={
          <ClassDetails
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentClass(null) }}
            setRefresh={setRefresh}
            currentClass={currentClass}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "addclass"}
        close={() => setIsOffCanvasOpen({ state: false, name: "" })}
        content={
          <AddOrEditClass
            close={() => setIsOffCanvasOpen({ state: false, name: "" })}
            setRefresh={setRefresh}
            currentClass={currentClass}
          />
        }
      />

      <CustomOffCanvas
        open={isOffCanvasOpen.state && isOffCanvasOpen?.name === "editclass"}
        close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setCurrentClass(null) }}
        content={
          <AddOrEditClass
            close={() => { setIsOffCanvasOpen({ state: false, name: "" }); setClasses(null) }}
            setRefresh={setRefresh}
            currentClass={currentClass}
          />
        }
      />

    </div>
  )
}

export default Classes
